var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinnedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 37,
    viewBox: "0 0 26 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.42 0.939941V4.53994H21.62V15.3399L25.22 20.7399V24.3399H14.42V36.9399H10.82V24.3399H0.0200195V20.7399L3.62002 15.3399V4.53994H1.82002V0.939941H23.42ZM7.22002 4.53994V16.4307L4.34722 20.7399H20.8928L18.02 16.4307V4.53994H7.22002Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinnedIcon);
export default __webpack_public_path__ + "static/media/pinned-icon.5980671f005b4060fb1e4ed654a0887e.svg";
export { ForwardRef as ReactComponent };